import { FetchKitQuery } from '../../__generated__/graphql/catalog/graphql'
import { Kit } from '../../types/graphql'

import { testimonial } from './sections'
import { collection, product, productGroupWithProductAvailability, variant } from './unorganized'

// "Kit" in Contentful
export const kitContent: FetchKitQuery['kit'] = {
  handle: 'womens-livingston-starter-kit',
  testimonials: [testimonial, testimonial, testimonial],
  testimonialsTitle: 'Awesome Humans',
  testimonialsSubtitle: 'Ipsum elit nisi ea officia laboris id dolor ad ut adipisicing amet.',
  sections: [
    {
      __typename: 'RawHtmlSection',
      id: 'Test Html Section',
      html: '<section class="did-you-know"><h2 class="did-you-know-title">Our Mission</h2><p data-testid="did-you-know-text" class="did-you-know-subtitle"> We believe every medical professional should have access to scrubs.</p><div class="stat-container"><div class="stat-list"><div class="stat-item"><div class="inner"> <img src="https://cdn.shopify.com/s/files/1/0298/0967/2276/files/mission-icon-earth.png?v=1614627000" alt="" /><p class="title">COUNTRIES WHERE WE’VE DONATED:</p><p class="stat">35</p></div></div><div class="stat-item"><div class="inner"> <img src="https://cdn.shopify.com/s/files/1/0298/0967/2276/files/mission-icon-hands.png?v=1614627000" alt="" /><p class="title">ORGANIZATIONS WE’VE PARTNERED WITH:</p><p class="stat">60</p></div></div><div class="stat-item"><div class="inner"> <img src="https://cdn.shopify.com/s/files/1/0298/0967/2276/files/mission-icon-heart.png?v=1614627000" alt="" /><p class="title">IMPACT OF A SET OF FIGS:</p><p class="stat">INVALUABLE</p></div></div></div></div> </section><style>section.did-you-know{margin:2rem 0;display:flex;flex-direction:column;justify-content:center;text-align:center;padding:0 24px}section.did-you-know .did-you-know-title{font-size:18px;font-weight:700;letter-spacing:2px;line-height:11px;text-align:center;margin-bottom:32px;text-transform:uppercase}section.did-you-know .did-you-know-subtitle{font-size:14px}section.did-you-know .stat-container{padding:4rem 0 5rem 0}section.did-you-know .stat-list{display:flex;flex-direction:column;justify-content:center}section.did-you-know img{height:80px;width:80px;margin:0 auto 20px}section.did-you-know .title{flex-direction:row;color:#707070;text-transform:uppercase;letter-spacing:1px;line-height:1.82;font-weight:600;font-size:11px;max-width:150px;margin:auto auto 1rem auto}section.did-you-know .stat{color:#707070;font-weight:600;font-size:1.1rem;letter-spacing:1px}@media (min-width: 810px){section.did-you-know{margin:4rem 0}section.did-you-know .stat-list{flex-direction:row}section.did-you-know .stat-item{padding:0 3rem}}</style>',
    },
  ],
  groupItemsByColor: true,
  defaultColors: "{ 'some-product-handle': 'Black' }",
  hideProductDetails: false,
  titleLockupImage: null,
  kitToggles: [],
  accordion: null,
  promotionalColoredTextSegments: [],
}

export const kit: Kit = {
  productGroup: {
    ...productGroupWithProductAvailability,
    handle: 'womens-livingston-starter-kit',
    defaultVariant: {
      ...variant,
      price: 5000,
      sku: 'sdf',
    },
    products: [
      {
        ...product,

        title: "Women's Livingston Starter Kit",
        description: 'Livingston™ Starter Kit',
        whyWeLove:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam ex elit, semper eget congue a, commodo et sem. Aliquam id venenatis diam, in dapibus lectus. Sed feugiat sed risus ac scelerisque.',
        badgeList: [],
        fitModelsDescriptions: [],
        rawMaterials: [],
        iconList: [
          {
            id: '9',
            label: 'Lauren',
            image:
              'https://cdn.shopify.com/s/files/1/0139/8942/files/Artboard_5_copy_10.svg?1397963845350479501',
            title: 'MODEL IS: XS / 5"8"',
          },
          {
            id: '10',
            label: '3 pockets',
            image:
              'https://cdn.shopify.com/s/files/1/0139/8942/files/Artboard_5_copy_10.svg?1397963845350479501',
            title: '3 pockets',
          },
        ],
        images: {
          nodes: [
            {
              id: 'id-1',
              type: 'ProductImage',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              name: null,
              color: 'No Color',
              fit: 'regular',
              index: 1,
              kind: 'no color',
              source:
                'https://cdn.shopify.com/s/files/1/3101/9164/products/Livingston-basic-scrub-pants_burgundy-1.jpg',
            },
            {
              id: 'id-2',
              type: 'ProductImage',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              name: null,
              color: 'No Color',
              fit: 'regular',
              index: 2,
              kind: 'no color',
              source:
                'https://cdn.shopify.com/s/files/1/3101/9164/products/Livingston-basic-scrub-pants_burgundy-2.jpg',
            },
            {
              id: 'id-3',
              type: 'ProductImage',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              name: null,
              color: 'No Color',
              fit: 'regular',
              index: 3,
              kind: 'no color',
              source:
                'https://cdn.shopify.com/s/files/1/0298/0967/2276/products/zamora_heatheredindigo_5_i_33f1382f-91cb-4aec-b4f7-58766bfa53f0.jpg',
            },
            {
              id: 'id-4',
              type: 'ProductImage',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              name: null,
              color: 'No Color',
              fit: 'regular',
              index: 4,
              kind: 'no color',
              source:
                'https://cdn.shopify.com/s/files/1/0298/0967/2276/products/Zamora-jogger-pant_5_4ba6c285-5f32-47bd-9c13-e3973a3d1c1d.jpg',
            },
            {
              color: 'Graphite',
              designFile: null,
              embroideryIconGroup: null,
              embroideryOffsets: null,
              fit: 'petite',
              id: 'id-5',
              index: 5,
              kind: 'wwlt',
              name: null,
              source:
                'https://cdn.shopify.com/s/files/1/0298/0967/2276/products/Whywelovethis_axim.jpg?v=1609984453',
              type: 'ProductImage',
            },
          ],
        },
        noindex: true,
        videos: {
          nodes: [],
        },
      },
    ],
  },
  collection: {
    ...collection,
    handle: 'womens-livingston-starter-kit',
    name: "Women's Livingston Starter Kit",
    productGroups: [productGroupWithProductAvailability, productGroupWithProductAvailability],
  },
}
